module.exports = __webpack_public_path__ + "platform-web/static/media/group.1c5e4336.svg";